#import "../../../engagement/graphql/fragments/sms-edition-engagement-stats-fragment.graphql"

fragment SmsDripEditionFragment on SmsEdition {
    id
    name
    htmlUrlPath
    content
    createdTime
    deletedTime
    modifiedTime
    lastSentTime
    status
    from {
        phone {
            numberFormatted
        }
    }
    campaign {
        id
        name
        deletedTime
        type
        htmlUrlPath
        status
        owner {
            id
        }
    }
    optOutText
    isFirstEdition
    delay {
        unit
        timespan
    }
    engagementStats {
        ...SmsEditionEngagementStatsFragment
        dripProgressionsGoalMetRate
        goalMetCount
        optoutRate
        optoutCount
    }
    queuedDripProgressions {
        totalCount
        pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
        }
        edges {
            node {
                id
                audienceMember {
                    id
                    audience {
                        id
                    }
                    entity {
                        id
                        name
                        avatarUrl
                        htmlUrlPath
                        ... on Contact {
                            emailAddresses {
                                primary {
                                    value {
                                        display
                                    }
                                }
                            }
                            accounts {
                                primary {
                                    id
                                    name
                                }
                            }
                        }
                    }
                }
                nextEditionSendTime
            }
        }
    }
    hasShortLink
}
